import { loader } from '@monaco-editor/react'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom/client'

import * as monaco from 'monaco-editor'
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker'
import cssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker'
import htmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker'
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker'
import tsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker'

import './index.css'
import 'react-resizable/css/styles.css'
import 'react-querybuilder/dist/query-builder.css'
import 'react-toastify/dist/ReactToastify.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ApolloProvider } from '@apollo/client'
import { client } from '@ui/lib/api/fetchGraphQL'
import { AppRouter } from '@ui/router/AppRouter'
import { enableMapSet } from 'immer'

enableMapSet()
const queryClient = new QueryClient()

self.MonacoEnvironment = {
  getWorker(_, label) {
    if (label === 'json') {
      return new jsonWorker()
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new cssWorker()
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new htmlWorker()
    }
    if (label === 'typescript' || label === 'javascript') {
      return new tsWorker()
    }
    return new editorWorker()
  },
}

loader.config({ monaco })
loader.init()

ReactDOM.createRoot(document.getElementById('root')!).render(
  // StrictMode renders components twice (on dev but not production) in
  // order to detect any problems with your code
  <React.StrictMode>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={client}>
          <AppRouter />
        </ApolloProvider>
      </QueryClientProvider>
    </CookiesProvider>
  </React.StrictMode>
)
